import React from 'react';
import { Table } from '@wienenergiegithub/ui-next';

const CmsTable = ({ isComparable, innerHTML, blueHeading }) => (
  <Table blueHeading={blueHeading} isComparable={isComparable} withParser>
    {innerHTML}
  </Table>
);
CmsTable.noMargin = true;

export default CmsTable;
